export interface IProviderRefundsSearchRequest {
  page?: number
  pageSize?: number
  patientFirstName?: string
  patientLastName?: string
  eocLegacy?: string
  providerGroupId?: string
  dosStartDate?: string
  dosEndDate?: string
}

export class ProviderRefundsSearchRequest implements IProviderRefundsSearchRequest {
  public page?: number | undefined
  public pageSize?: number | undefined
  public patientFirstName?: string | undefined
  public patientLastName?: string | undefined
  public eocLegacy?: string | undefined
  public providerGroupId?: string | undefined
  public dosStartDate?: string | undefined
  public dosEndDate?: string | undefined
}
